import { checkRoles } from '../utils/util';

export const PRESET_ROUTE = '/preset';
export const COMMAND_CENTER_ROUTE = '/command-center';

export const getDefaultPostLoginRoute = (): string => {
	return checkRoles('ROLE_SLASHCALL') ? COMMAND_CENTER_ROUTE : PRESET_ROUTE;
};
